
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'grouped-competency-multiselect',
  templateUrl: './grouped-competency-multiselect.component.html',
  providers: [
    // part of ControlValueAccessor to allow this component to work with 'formControlName'
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GroupedCompetencyMultiselectComponent),
      multi: true
    }
  ]
})
export class GroupedCompetencyMultiselectComponent implements ControlValueAccessor, OnInit {
  @Input() allWorkerCompetenciesData: any[] = [];
  public options: any[] = [];

  // --- part of ControlValueAccessor ---
  public value: any;
  public onChange: any = () => {};
  public onTouched: any = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  // --- end of ControlValueAccessor ---

  ngOnInit() {
    this.getAllWorkerCompetencies();
  }

  private getAllWorkerCompetencies() {
    // TODO: Revisit if this legacy component will remain in use. Role -> Worker Admin
    // If kept, migrate this grouping logic from `allWorkerRequired` to `applyToParty`.
    const competencies = this.allWorkerCompetenciesData.map((element) => ({
      label: element.value,
      value: element.id,
      allWorkerRequired: element.allWorkerRequired,
    }));

    competencies.sort((a, b) => {
      if (a.allWorkerRequired && !b.allWorkerRequired) {
        return 1;
      }
      if (!a.allWorkerRequired && b.allWorkerRequired) {
        return -1;
      }
      return a.label.localeCompare(b.label);
    });

    const allWorkerCompetencies = [];
    let group1Added = false;
    let group2Added = false;

    competencies.forEach((competency) => {
      if (!competency.allWorkerRequired && !group1Added) {
        allWorkerCompetencies.push({ label: 'Lead Worker', value: null, allWorkerRequired: false, disabled: true });
        group1Added = true;
      }
      if (competency.allWorkerRequired && !group2Added) {
        allWorkerCompetencies.push({ label: 'All Workers', value: null, allWorkerRequired: true, disabled: true });
        group2Added = true;
      }
      allWorkerCompetencies.push(competency);
    });

    this.options = allWorkerCompetencies;
  }
}
